
import { getUserConversations } from '../../../Components/Conversations/middleware/conversation-fire'
import firebase from '../../../firebase'
import { getUserProfileData } from './user-profile-fire'

var db = firebase.firestore();

export const initSignIn = (signInResponse, next, chatToken) => {

  var {user: {uid, email}} = signInResponse

  return getUserConversations(uid, next, chatToken)

    .then(signInResponse => getUserProfileData({
      uid,
      email
    }, next))

    .then(() => signInResponse)

}


// WEBPACK FOOTER //
// ./src/Components/Login/actions/init-signIn.js